import React from 'react'
import styled from 'styled-components'

const Media = ({ children, onRemove }) => (
  <MediaLayout>
    <MediaContentLayout>{children}</MediaContentLayout>
    <MediaRightLayout>
      <button className="delete" onClick={onRemove} />
    </MediaRightLayout>
  </MediaLayout>
)

export default Media

export const MediaLayout = ({ children }) => (
  <div className="media">{children}</div>
)

export const MediaRightLayout = ({ children }) => (
  <div className="media-right">{children}</div>
)

export const MediaContentLayout = styled.div.attrs({
  className: 'media-content',
})`
  overflow: hidden !important;
`



// WEBPACK FOOTER //
// ./src/components/views/layouts/Media.js